<template>
  <div class="component-upload-image">
    <el-upload
      multiple
      :action="uploadImgUrl"
      list-type="picture-card"
      :on-success="handleUploadSuccess"
      :before-upload="handleBeforeUpload"
      :http-request="httpRequest"
      :limit="limit"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      name="file"
      :on-remove="handleRemove"
      :show-file-list="true"
      :headers="headers"
      :file-list="fileList"
      :on-preview="handlePictureCardPreview"
      :class="{ hide: showUploadBtn }"
      :disabled="!isShowUploadBtn"
    >
      <div style="font-size: 20px">+</div>
      <!-- :disabled="true"  去掉删除图标 -->
      <!-- <el-icon class="avatar-uploader-icon"><plus /></el-icon> -->
    </el-upload>
    <!-- 上传提示 -->
    <div class="el-upload__tip" v-if="showTip">
      请上传
      <template v-if="fileSize">
        大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b>
      </template>
      <template v-if="fileType">
        格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b>
      </template>
      的文件
    </div>

    <el-dialog
      v-model="dialogVisible"
      title="预览"
      width="800px"
      append-to-body
    >
      <img
        :src="dialogImageUrl"
        style="display: block; max-width: 100%; margin: 0 auto"
      />
    </el-dialog>
  </div>
</template>

<script setup>
import { requestToken } from "../../common/js/request_token";
import { getPictureToken } from "../../server/jigou/org";
import * as qiniu from "qiniu-js";

// import useUserStore from '@/store/modules/user'
import { v4 as uuidv4 } from "uuid";
import { deleteSignImage } from "../../server/jigou/order";
import { ref, reactive, getCurrentInstance, computed, watch } from "vue";
const props = defineProps({
  modelValue: [String, Object, Array],
  // 图片数量限制
  limit: {
    type: Number,
    default: 5,
  },
  // 大小限制(MB)
  fileSize: {
    type: Number,
    default: 5,
  },
  // 文件类型, 例如['png', 'jpg', 'jpeg']
  fileType: {
    type: Array,
    default: () => ["png", "jpg", "jpeg"],
  },
  // 是否显示提示
  isShowTip: {
    type: Boolean,
    default: true,
  },
    // 是否审核通过不可修改
  isShowUploadBtn: {
    type: Boolean,
    default: true,
  },
});

const { proxy } = getCurrentInstance();
const emit = defineEmits();
const number = ref(0);
const uploadList = ref([]);
const dialogImageUrl = ref("");
const dialogVisible = ref(false);
// const baseUrl = import.meta.env.VITE_APP_BASE_API;
const baseUrl = "";
const uploadImgUrl = ref(process.env.VUE_APP_API_BASE_URL + "/common/upload"); // 上传的图片服务器地址
const headers = ref({ Authorization: "Bearer " + requestToken() });
const fileList = ref([]);
// const uid = computed(() => useUserStore().uid);
const showTip = computed(
  () => props.isShowTip && (props.fileType || props.fileSize)
);
const showUploadBtn = computed(() => {
  if (props.isShowUploadBtn) {
    return fileList.value.length >= props.limit
  } else {
    return true;
  }
});

watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      // 首先将值转为数组
      const list = Array.isArray(val) ? val : props.modelValue.split(",");
      // 然后将数组转为对象数组
      fileList.value = list.map((item) => {
        if (typeof item === "object" && item.url === "string") {
          item = { id: item.id, url: item.url };
        }
        return item;
      });
    } else {
      fileList.value = [];
      return [];
    }
  },
  { deep: true, immediate: true }
);

// 删除图片  需要请求后台接口
function handleRemove(file, files) {
  if (file.id == 0) {
    emit("update:modelValue", filterArrayData(fileList.value));
  } else {
    deleteSignImage(file.id).then((res) => {
      if (res != false) {
        emit("update:modelValue", filterArrayData(fileList.value));
      } else {
        proxy.$modal.msgError("删除图片失败");
      }
    });
  }
}

// 上传成功回调
function handleUploadSuccess(res) {
  uploadList.value.push({ id: 0, url: res.fileUrl });
  if (uploadList.value.length === number.value) {
    fileList.value = filterArrayData(fileList.value);
    fileList.value = fileList.value
      .filter((f) => f.url !== undefined)
      .concat(uploadList.value);
    uploadList.value = [];
    number.value = 0;
    emit("update:modelValue", filterArrayData(fileList.value));
    proxy.$modal.closeLoading();
  }
}

function httpRequest(file) {
  console.log("httpRequest");
  // 获取签名
  getPictureToken().then((res) => {
    var keyPrefix = "classroom/" + 0 + "/";
    // https://developer.qiniu.com/kodo/1283/javascript
    const token = res.token,
      key = keyPrefix + uuidv4() + "." + file.file.name.split(".")[1],
      putExtra = {
        fname: file.name,
        // mimeType: file.type,
      },
      config = {
        useCdnDomain: true,
        region: res.region,
      };

    let observer = {
      next(res) {
        console.log(res);
        console.log("已上传大小，单位为字节：" + res.total.loaded);
        console.log("本次上传的总量控制信息，单位为字节：" + res.total.size);
        console.log("当前上传进度，范围：0～100：" + res.total.percent);
      },
      error(err) {
        console.log(err);
        console.log(err.code);
        console.log(err.message);
        console.log(err.isRequestError);
        console.log(err.reqId);
      },
      complete(res) {
        console.log(res);
        handleUploadSuccess({ fileUrl: res.data.url });
      },
    };

    const observable = qiniu.upload(file.file, key, token, putExtra, config);
    const subscription = observable.subscribe(observer); // 上传开始
    console.log(subscription);
  });
}

// 上传前loading加载
function handleBeforeUpload(file) {
  console.log("handleBeforeUpload");
  let isImg = false;
  if (props.fileType.length) {
    let fileExtension = "";
    if (file.name.lastIndexOf(".") > -1) {
      fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
    }
    isImg = props.fileType.some((type) => {
      if (file.type.indexOf(type) > -1) return true;
      if (fileExtension && fileExtension.indexOf(type) > -1) return true;
      return false;
    });
  } else {
    isImg = file.type.indexOf("image") > -1;
  }
  if (!isImg) {
    proxy.$modal.msgError(
      `文件格式不正确, 请上传${props.fileType.join("/")}图片格式文件!`
    );
    return false;
  }
  if (props.fileSize) {
    const isLt = file.size / 1024 / 1024 < props.fileSize;
    if (!isLt) {
      proxy.$modal.msgError(`上传头像图片大小不能超过 ${props.fileSize} MB!`);
      return false;
    }
  }
  proxy.$modal.loading("正在上传图片，请稍候...");
  number.value++;
}

// 文件个数超出
function handleExceed() {
  proxy.$modal.msgError(`上传文件数量不能超过 ${props.limit} 个!`);
}

// 上传失败
function handleUploadError() {
  proxy.$modal.msgError("上传图片失败");
  proxy.$modal.closeLoading();
}

// 预览
function handlePictureCardPreview(file) {
  console.log("预览id" + file.id);
  dialogImageUrl.value = file.url;
  dialogVisible.value = true;
}

// 筛选数据
function filterArrayData(list) {
  let imgsList = [];
  for (let i in list) {
    if (undefined !== list[i].url && list[i].url.indexOf("blob:") !== 0) {
      imgsList.push(list[i]);
    }
  }
  return imgsList;
}
</script>

<style scoped>
/**
超出图片限制隐藏上传图片框
*/
:deep(.hide .el-upload--picture-card) {
  display: none;
}
/** 设置上传框大小以及设置上传图片成功之后得图片大小 */
:deep(.el-upload) {
  width: 100px;
  height: 100px;
}
:deep(.el-upload .el-upload-dragger) {
  width: 100%;
}
:deep(.el-upload-list--picture-card .el-upload-list__item) {
  width: 100px;
  height: 100px;
}
</style>
